import { render, staticRenderFns } from "./GTopicSubject.vue?vue&type=template&id=4761769b&scoped=true&"
import script from "./GTopicSubject.vue?vue&type=script&lang=ts&"
export * from "./GTopicSubject.vue?vue&type=script&lang=ts&"
import style0 from "./GTopicSubject.vue?vue&type=style&index=0&id=4761769b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4761769b",
  null
  
)

export default component.exports